"use client";

import React from "react";
import Image from "next/image";
import "../../css/MeasurableOutcomes.css";

import centerLogo from "../../assets/images/centerchip.svg";
import circleRing from "../../assets/images/circle.png";


import processIcon from "../../assets/images/mprocess.svg";
import complianceIcon from "../../assets/images/mcompliance.svg";
import engagementIcon from "../../assets/images/engage.svg";
import measurementIcon from "../../assets/images/measurement.svg";

const MeasurableOutcomes = () => {
  return (
    <section className="outcomes-section">
      <h2 className="outcomes-title">MEASURABLE OUTCOMES</h2>

      <p className="outcomes-subtitle">
        CareAscendium delivers quantifiable improvements across all aspects of
        skilled nursing facility operations
      </p>

      <div className="outcomes-container">
        <div className="outcomes-center-circle">
          <Image
            src={circleRing}
            alt="Circle Ring"
            fill
            className="circle-ring-image"
            priority
          />
          <div className="center-logo-box">
            <Image src={centerLogo} alt="Center Logo" width={50} height={50} />
          </div>
        </div>

        <div className="outcomes-grid">
          <div className="outcome-card curve-bottom-right">
            <h4>Process Outcomes</h4>
            <p>
              Streamlined workflows and automated processes that save time and
              reduce administrative burden
            </p>

            <div className="card-icon inside-curve">
              <Image src={processIcon} alt="Process" width={22} height={22} />
            </div>
          </div>

          <div className="outcome-card curve-bottom-left">
            <h4>Compliance Outcomes</h4>
            <p>
              Enhanced regulatory compliance and reduced risk through automated
              monitoring and tracking
            </p>

            <div className="card-icon inside-curve">
              <Image src={complianceIcon} alt="Compliance" width={22} height={22} />
            </div>
          </div>

          <div className="outcome-card curve-top-right">
            <h4>Engagement & Culture Outcomes</h4>
            <p>
              Improved satisfaction and collaboration across all stakeholders
              in the care ecosystem
            </p>

            <div className="card-icon inside-curve">
              <Image src={engagementIcon} alt="Engagement" width={22} height={22} />
            </div>
          </div>

          <div className="outcome-card curve-top-left">
            <h4>Our Measurement Approach</h4>
            <p>
              We use a comprehensive methodology to track and validate outcomes
              across all facility operations
            </p>

            <div className="card-icon inside-curve">
              <Image src={measurementIcon} alt="Measurement" width={22} height={22} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeasurableOutcomes;
